<template>
  <div id="quickquote-extended-travel-step-1-component">
    <h1
      class="push-down"
      data-test="quickquote-extended-travel-headline"
      v-html="contentModel.SharedFields.LabelHeadingStep1"
    />
    <div v-html="contentModel.TextExtendedTravel" />
    <section>
      <article class="flow-group">
        <div class="control">
          <h3-and-tooltip
            :h3="contentModel.LabelCoverDestination"
            data-test="quickquote-ext-travel-headline-coverage"
            :tooltip="contentModel.TooltipCoverDestination"
          />
          <div
            v-if="contentModel.TextCoverDestination !== ''"
            class="info-box is-shown info-box-no-arrow"
            v-html="contentModel.TextCoverDestination"
          />

          <div class="row">
            <div class="radio-stacked small-12 medium-6 columns">
              <Field
                id="CoverageWorld"
                v-model="vueModelData.TemplateModel.DestinationRefId"
                :rules="'required'"
                type="radio"
                name="Coverage"
                value="1000002"
                :label="contentModel.FieldNameCoverDestination"
                data-test="quickquote-ext-travel-input-coverage-world"
              />
              <label for="CoverageWorld" class="no-margin" v-html="contentModel.LabelEntireWorld" />
            </div>
          </div>
          <div class="row push-down">
            <div class="radio-stacked small-12 medium-6 columns">
              <Field
                id="CoverageEU"
                v-model="vueModelData.TemplateModel.DestinationRefId"
                :rules="'required'"
                type="radio"
                name="Coverage"
                value="1000001"
                :label="contentModel.FieldNameCoverDestination"
                data-test="quickquote-ext-travel-input-coverage-europe"
              />
              <label for="CoverageEU" class="no-margin" v-html="contentModel.LabelEuropeCountries" />
            </div>
            <ValidationError name="Coverage" data-test="quickquote-ext-travel-validation-coverage" />
          </div>
          <p>
            <a class="round-arrow-with-text" data-collapse="textEUCountries">
              <span class="round-arrow down" />
              <span v-html="contentModel.LabelEUCountries" />
            </a>
          </p>
          <div id="textEUCountries" class="collapse-target" v-html="contentModel.TextEUCountries" />
        </div>
        <div class="control push-up">
          <h3-and-tooltip
            :h3="contentModel.LabelWhenDoYouLeave"
            data-test="quickquote-ext-travel-headline-departure"
            :tooltip="contentModel.TooltipWhenDoYouLeave"
          />
          <div class="row">
            <div class="small-12 medium-6 columns">
              <Field
                :model-value="vueModel.TemplateModel.LeaveDate"
                name="DepartureDate"
                :rules="{
                  required: true,
                  valid_date_range: [earliestDepartureDate, latestDepartureDate]
                }"
                :label="contentModel.FieldNameLeaveDate"
              >
                <date-picker
                  id="departuredate"
                  v-model="vueModelData.TemplateModel.LeaveDate"
                  :date="vueModelData.TemplateModel.LeaveDate"
                  name="DepartureDate"
                  class="datepicker"
                  :placeholder="contentModel.PlaceholderDateFields"
                  :min-date="earliestDepartureDate"
                  :max-date="latestDepartureDate"
                  data-test="quickquote-ext-travel-input-departure"
                />
              </Field>
            </div>
          </div>
          <ValidationError name="DepartureDate" data-test="quickquote-ext-travel-validation-departure" />
        </div>
        <hr />
        <div class="control push-up">
          <h-3-and-tooltip
            :h3="contentModel.LabelWhenDoYouReturn"
            data-test="quickquote-ext-travel-headline-return"
            :tooltip="contentModel.TooltipWhenDoYouReturn"
          />
          <div class="row">
            <div class="small-12 medium-6 columns">
              <Field
                :model-value="vueModelData.TemplateModel.ReturnDate"
                name="ReturnDate"
                :rules="{
                  required: true,
                  valid_date_range: [earliestReturnDate, latestReturnDate]
                }"
                :label="contentModel.FieldNameReturnDate"
              >
                <date-picker
                  id="returndate"
                  v-model="vueModelData.TemplateModel.ReturnDate"
                  :date="vueModelData.TemplateModel.ReturnDate"
                  name="ReturnDate"
                  class="datepicker"
                  :placeholder="contentModel.PlaceholderDateFields"
                  :min-date="earliestReturnDate"
                  :max-date="latestReturnDate"
                  data-test="quickquote-ext-travel-input-return"
                />
              </Field>
            </div>
          </div>
          <ValidationError
            name="ReturnDate"
            data-test="quickquote-ext-travel-validation-return"
            :overrides="{
              required: contentModel.LabelDateHelpInformation
            }"
          />
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import QuickQuoteMixin from './QuickQuoteMixin.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import DatePicker from '@/components/UI/Pickadate.vue';

moment.locale(window.language);

export default {
  name: 'ExtendedTravelQuickQuote',
  components: { H3AndTooltip, ValidationError, DatePicker },
  mixins: [QuickQuoteMixin],
  props: {
    contentModel: {
      type: Object,
      default() {
        return {};
      }
    },
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    stepModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dateFormat: window.dateFormat,
      cprArrayId: 0,
      vueModelData: this.vueModel
    };
  },
  computed: {
    personalInformationForTagManager() {
      return {};
    },
    earliestDepartureDate() {
      return moment().startOf('day').subtract(59, 'days');
    },
    latestDepartureDate() {
      return moment().startOf('day').add(1, 'year');
    },
    earliestReturnDate() {
      return moment(this.vueModel.TemplateModel.LeaveDate).add(60, 'days');
    },
    latestReturnDate() {
      return moment(this.vueModel.TemplateModel.LeaveDate).add(1, 'year');
    },
    returnDateValidationSpanString() {
      return this.vueModel.TemplateModel.LeaveDate === null
        ? null
        : this.earliestReturnDate.format(this.dateFormat) + ',' + this.latestReturnDate.format(this.dateFormat);
    }
  },
  created() {
    this.vueModelData.TemplateModel.Travelers =
      this.vueModelData.TemplateModel.Travelers === null
        ? [
            {
              Id: this.cprArrayId,
              SocialSecurityNumber: null
            }
          ]
        : this.vueModelData.TemplateModel.Travelers;
  },
  mounted() {
    this.disableTimeUTCConversion();
  },
  unmounted() {
    this.enableTimeUTCConversion();
  },
  methods: {
    addCpr() {
      this.cprArrayId++;
      this.vueModelData.TemplateModel.NumberOfTravelers++;
      this.vueModelData.TemplateModel.Travelers.push({
        Id: this.cprArrayId,
        SocialSecurityNumber: null
      });
    },
    removeCpr(index) {
      this.vueModelData.TemplateModel.NumberOfTravelers--;
      this.vueModelData.TemplateModel.Travelers.splice(index, 1);
    }
  }
};
</script>
